export default {
  setSmartHomeDevices: (state, smartHomeDevices) => {
    state.smartHomeDevices = smartHomeDevices;
  },

  updateSmartHomeDevice: (state, smartHomeDevice) => {
    state.smartHomeDevices = state.smartHomeDevices.map(item => {
      if (item.id === smartHomeDevice.id) {
        return Object.assign({}, item, smartHomeDevice);
      }

      return item;
    });
  },

  setApartmentSmartHomeDevice: (state, { id, apartment }) => {
    state.smartHomeDevices = state.smartHomeDevices.map(item => {
      if (item.id === id) {
        return Object.assign({}, item, {
          apartment: Object.assign({}, item.apartment, apartment)
        });
      }

      return item;
    });
  },

  setSmartHomeDeviceStatuses: (state, smartHomeDeviceStatuses) => {
    state.smartHomeDeviceStatuses = smartHomeDeviceStatuses;
  },
};
